import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Page} from '../../../common/services';


@Component({
  selector: 'app-page-list-modal',
  templateUrl: './page-list-modal.component.html',
  styleUrls: ['./page-list-modal.component.scss']
})
export class PageListModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: Page[],
              public dialogRef: MatDialogRef<PageListModalComponent>) { }

  ngOnInit() {
  }

}
